import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setOnlineStatus } from "@/store/redux/slices/network/network_slice";

function NetworkStatusProvider({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if electronAPI exists before using it
    const isElectron = window.IS_ELECTRON || window.electronAPI !== undefined;
    const isOnline =
      isElectron && window.electronAPI
        ? window.electronAPI.isOnline()
        : navigator.onLine;

    dispatch(setOnlineStatus(isOnline));

    // Set up listeners
    let cleanup;
    if (isElectron && window.electronAPI) {
      cleanup = window.electronAPI.onNetworkStatusChange((isOnline) => {
        dispatch({
          type: "network/statusChanged",
          payload: { isOnline },
        });
        dispatch(setOnlineStatus(isOnline));
      });
    } else {
      // Fallback for web
      const handleOnline = () => {
        dispatch({
          type: "network/statusChanged",
          payload: { isOnline: true },
        });
        dispatch(setOnlineStatus(true));
      };

      const handleOffline = () => {
        dispatch({
          type: "network/statusChanged",
          payload: { isOnline: false },
        });
        dispatch(setOnlineStatus(false));
      };

      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);

      cleanup = () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    }

    return cleanup;
  }, [dispatch]);

  return children;
}

export default NetworkStatusProvider;
